"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const parents_service_types_1 = require("@seneca/parents-service-types");
function formatStudyTimeDate(date, period) {
    const formatDateNumber = (date) => {
        if (date >= 0 && date < 10)
            return `0${date}`;
        return `${date}`;
    };
    switch (period) {
        case parents_service_types_1.StudentActivityBucketPeriod.day:
            if (!date.year || !date.month || !date.day)
                throw new client_library_1.ExtendableError('Incorrect day format. Expected valid day, month and year');
            return `${date.year}-${formatDateNumber(date.month)}-${formatDateNumber(date.day)}`;
        case parents_service_types_1.StudentActivityBucketPeriod.week:
            if (!date.year || !date.week)
                throw new client_library_1.ExtendableError('Incorrect week format. Expected valid week and year');
            return `${date.year}-${formatDateNumber(date.week)}`;
        case parents_service_types_1.StudentActivityBucketPeriod.month:
            if (!date.year || !date.month)
                throw new client_library_1.ExtendableError('Incorrect month format. Expected valid month and year');
            return `${date.year}-${formatDateNumber(date.month)}`;
    }
}
exports.default = formatStudyTimeDate;
//# sourceMappingURL=formatStudyTimeDate.js.map